module.exports = "./images/originOS6-white.svg";